import styled from 'styled-components'

export const VisuallyHidden = styled.span`
	border: 0;
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	white-space: nowrap;
	width: 1px;
	clip-path: inset(50%);
`
